import { render } from "./devDash.vue?vue&type=template&id=24b8ffa6&scoped=true"
import script from "./devDash.vue?vue&type=script&lang=js"
export * from "./devDash.vue?vue&type=script&lang=js"

import "./devDash.vue?vue&type=style&index=0&id=24b8ffa6&lang=css"
import "./devDash.vue?vue&type=style&index=1&id=24b8ffa6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b8ffa6"]])

export default __exports__